import { render, staticRenderFns } from "./middleResultsDetail.vue?vue&type=template&id=c4f983c8&scoped=true&"
import script from "./middleResultsDetail.vue?vue&type=script&lang=js&"
export * from "./middleResultsDetail.vue?vue&type=script&lang=js&"
import style0 from "./middleResultsDetail.vue?vue&type=style&index=0&id=c4f983c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f983c8",
  null
  
)

export default component.exports